import React, { useState } from "react";
import { useData } from "@pure-ptr/react";
import { IconButton, Tooltip } from "@mui/material";
import { ClientCreationStages } from "../ClientCreationStages/ClientCreationStages";
import {
    getClientCreationStages,retryClientRegistration
} from "../../../../store/api/clients";
import { toast } from "react-toastify";

const ClientCreationStagesOptions = ({ rowData,isSuperAdmin }) => {
    const [openCreationStages, setOpenCreationStages] = useState({
        open: false,
        clientId: null,
    });
    const [isRetry, setIsRetry] = useState(false);
    
    const {
        data: creationnStagesData,
        isPending: isFetchingStages,
        error: importError,
        reload,
    } = useData(async () => {
        if (!openCreationStages?.clientId) return;
        const clientCreationStagesResponse = await getClientCreationStages(
            openCreationStages?.clientId
        );
        return clientCreationStagesResponse;
    }, [openCreationStages?.clientId]);

    
    const { } = useData(async () => {
        if (!isRetry) return;
        setOpenCreationStages({
                            open: false,
                            clientId: null,
                        })
        toast.info("Retry registration in progress. We will let you know once process is completed.",{
            autoClose:3000
        });
        try{
             const res = await retryClientRegistration(rowData);
             return res;
        }catch{
        }
        finally{
            setIsRetry(false);
        }
        
    }, [isRetry]);
    

    return (
        <div>
            {rowData?.status === "COMPLETED" && (
                <IconButton
                    color="primary"
                    className="p-1"
                    aria-label="success"
                    onClick={() =>
                        setOpenCreationStages({
                            open: true,
                            clientId: rowData?.clientId,
                        })
                    }
                    size="large"
                >
                    <Tooltip title="Client Created Successfully">
                        <i
                            className="fas fa-check-circle text-success ml-2 null"
                            style={{ fontSize: "1.3rem" }}
                        />
                    </Tooltip>
                </IconButton>
            )}

            {((rowData?.status === "FAILED") && isSuperAdmin) && (
                <IconButton
                    color="primary"
                    className="p-1"
                    aria-label="failed"
                    onClick={() =>
                        setOpenCreationStages({
                            open: true,
                            clientId: rowData?.clientId,
                        })
                    }
                    size="large"
                >
                    <Tooltip title="Client Creation Failed">
                        <i
                            className="fas fa-exclamation-circle text-danger ml-2"
                            style={{ fontSize: "1.3rem" }}
                        ></i>
                    </Tooltip>
                </IconButton>
            )}

            {((rowData?.status === "IN_PROGRESS") && isSuperAdmin) && (
                <IconButton
                    color="primary"
                    className="p-1"
                    aria-label="pending"
                    onClick={() =>
                        setOpenCreationStages({
                            open: true,
                            clientId: rowData?.clientId,
                        })
                    }
                    size="large"
                >
                    <Tooltip title="Client Creation Pending">
                        <i
                            className="fas fa-hourglass-half text-warning ml-2"
                            style={{ fontSize: "1.3rem" }}
                        />

                    </Tooltip>
                </IconButton>
            )}
            <ClientCreationStages
                open={openCreationStages?.open}
                handleClose={() =>
                    setOpenCreationStages({
                        open: false,
                        clientId: null,
                    })
                }
                isPending={isFetchingStages != null}
                data={creationnStagesData}
                reload={reload}
                retry={()=>setIsRetry(true)}
            />
        </div>
    );
};

export default ClientCreationStagesOptions;
